export type FilterValue = number | string | boolean;
export type FilterData = Record<string, FilterValue>

export abstract class Filter {
    public abstract getInitialValues(result: FilterData): void;
    public abstract getFilter(filterData: FilterData): any;
    public abstract parse(filterData: FilterData, result: FilterData): void;
    public abstract getCriteria(filterData: FilterData):Promise<string> | string;
}